import { createRoute } from '@tanstack/react-router';
import { NewClaimCreate } from '../new-claim/create.js';
import { NewClaimForm } from '../new-claim/index.js';
import { rootRoute } from './index.js';

export const newClaimCreateRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/new-claim',
    component: NewClaimCreate,
});

export const newClaimFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/new-claim/$id',
    component: NewClaimForm,
});
